import { Box, Chip, Tooltip } from "@mui/joy";
import type { MailPlaceholderDefinition } from "api/mailTemplates/MailTemplate.typed";
import { colorTokens, textTokens } from "../../../../styles/globalStyles";
import { mailPlaceholderPresentableLabel, mailPlaceholderTooltip } from "../mailEditorShared";
import { setMailPlaceholderDragData } from "../mailEditorDnD";

type MailConditionalBooleanChipsProps = {
  items: MailPlaceholderDefinition[];
  selectedKey: string;
  onSelectKey: (key: string) => void;
  canEdit: boolean;
};

export default function MailConditionalBooleanChips(props: MailConditionalBooleanChipsProps) {
  const { items, selectedKey, onSelectKey, canEdit } = props;

  if (items.length === 0) {
    return null;
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, alignItems: "center" }}>
      {items.map((d) => {
        const isSelected = selectedKey === d.key;

        return (
          <Tooltip key={d.key} title={mailPlaceholderTooltip(d)}>
            <Chip
              size="sm"
              variant="outlined"
              draggable={canEdit}
              onDragStart={(e) => {
                if (canEdit) {
                  setMailPlaceholderDragData(e, d.key);
                }
              }}
              onClick={() => canEdit && onSelectKey(d.key)}
              disabled={!canEdit}
              sx={{
                borderColor: isSelected ? textTokens.color.title : colorTokens.border.strong,
                boxShadow: isSelected ? `0 0 0 1px ${textTokens.color.title}` : undefined,
                bgcolor: isSelected ? "rgba(255, 208, 0, 0.12)" : undefined,
                maxWidth: "100%",
                fontSize: 12,
                cursor: canEdit ? "grab" : "default",
                touchAction: "none",
                minHeight: { xs: 40, sm: 32 },
                "&:active": { cursor: canEdit ? "grabbing" : "default" },
              }}
            >
              {mailPlaceholderPresentableLabel(d.key, items)}
            </Chip>
          </Tooltip>
        );
      })}
    </Box>
  );
}
